/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationRulesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationRulesInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationObligationRulesQuery = {
  __typename?: 'Query';
  internalRegulationObligationRules: {
    __typename: 'InternalRegulationObligationRuleConnection';
    edges: Array<{
      __typename: 'InternalRegulationObligationRuleEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationObligationRule';
        id: string;
        name: string;
        obligationId: string;
        reviewStatus?: Types.IInternalRegulationObligationRuleReviewStatus | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationObligationRulesDocument = gql`
  query InternalRegulationObligationRules($input: InternalRegulationObligationRulesInput, $first: Int, $after: String) {
    internalRegulationObligationRules(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          name
          obligationId
          reviewStatus
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationObligationRulesQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationRulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationObligationRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationRulesQuery,
    IInternalRegulationObligationRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRegulationObligationRulesQuery, IInternalRegulationObligationRulesQueryVariables>(
    InternalRegulationObligationRulesDocument,
    options,
  );
}
export function useInternalRegulationObligationRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationRulesQuery,
    IInternalRegulationObligationRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRegulationObligationRulesQuery, IInternalRegulationObligationRulesQueryVariables>(
    InternalRegulationObligationRulesDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRegulationObligationRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationRulesQuery,
    IInternalRegulationObligationRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRulesQuery,
  IInternalRegulationObligationRulesQueryVariables
>;
export function useInternalRegulationObligationRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRulesQuery,
        IInternalRegulationObligationRulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRulesQuery | undefined,
  IInternalRegulationObligationRulesQueryVariables
>;
export function useInternalRegulationObligationRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRulesQuery,
        IInternalRegulationObligationRulesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalRegulationObligationRulesQuery,
    IInternalRegulationObligationRulesQueryVariables
  >(InternalRegulationObligationRulesDocument, options);
}
export type InternalRegulationObligationRulesQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRulesQuery
>;
export type InternalRegulationObligationRulesLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRulesLazyQuery
>;
export type InternalRegulationObligationRulesSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRulesSuspenseQuery
>;
export type InternalRegulationObligationRulesQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationRulesQuery,
  IInternalRegulationObligationRulesQueryVariables
>;
